import { request } from '../http';

const scheduleService = {
    getByDay: (dataAgendamento) => {
        return request.post('/schedule/filter', { dataAgendamento });
    },
    getById: (idAgendamento) => {
        return request.post('/schedule/filter', { idAgendamento });
    },
    getReportPatient: (body) => {
        return request.post('/schedule/report', body);
    },
    getReportPartner: (body) => {
        return request.post('/pointControl/report', body);
    },
    post: (body) => {
        return request.post('/schedule', body);
    },
    patch: (body, id) => {
        return request.patch(`/schedule/${id}`, body);
    },
    delete: (id) => {
        return request.delete(`/schedule/${id}`);
    }
};

export {
    scheduleService
};
